import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SEOMeta } from '../components/SEOMeta';
import {
  BuybackValueProp,
  BuybackDevices,
  BuybackStats,
  BuybackPoweredBy,
} from '../components/sections/buyback';
import { FinalCTA } from '../components/sections/home';
import { RelatedPages } from '../components/RelatedPages';
import styles from './Buyback.module.css';

export function Buyback() {
  const { t } = useTranslation('buyback');
  const [iframeLoaded, setIframeLoaded] = useState(false);

  return (
    <>
      <SEOMeta title={t('meta.title')} description={t('meta.description')} />

      <div className={styles.aboveFold}>
        <div className={styles.aboveFoldBg} />
        <div className={styles.heroZone}>
          <div className={styles.heroContent}>
            <h1>{t('hero.title')}</h1>
            <p className={styles.heroSubtitle}>{t('hero.subtitle')}</p>
          </div>
        </div>
        <div className={styles.demoZone}>
          <div className={styles.browser}>
            <div className={styles.chromeBar}>
              <div className={styles.dots}>
                <span className={styles.dot} />
                <span className={styles.dot} />
                <span className={styles.dot} />
              </div>
              <div className={styles.urlBar}>quelbonplan-bol.comparecycle.com</div>
            </div>
            <div className={styles.iframeWrap}>
              <div className={`${styles.loader} ${iframeLoaded ? styles.loaderHidden : ''}`}>
                <div className={styles.spinner} />
                <span>{t('hero.loading')}</span>
              </div>
              <iframe
                src="https://quelbonplan-bol.comparecycle.com/"
                title="CompaRecycle"
                loading="lazy"
                onLoad={() => setIframeLoaded(true)}
              />
            </div>
          </div>
          <div className={styles.scrollIndicator} aria-hidden="true">
            <div className={styles.chevron} />
            <div className={styles.chevron} />
            <div className={styles.chevron} />
          </div>
        </div>
      </div>

      <BuybackValueProp />
      <BuybackDevices />
      <BuybackStats />
      <BuybackPoweredBy />
      <RelatedPages currentFrPath="/buyback" />
      <FinalCTA ns="buyback" prefix="finalCTA" />
    </>
  );
}
